<script setup lang="ts">
import type { CmsElementCategoryInfo } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementCategoryInfo;
}>();

const { heading, text, image, link } = props.content?.config ?? {}

</script>

<template>
  <div class="section section-products--main" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head mb-0">
        <div class="row align-items-center">
          <div class="col-md-8 col-lg-5 offset-lg-2">
            <h2>{{ heading?.value }}</h2>

            <h3>{{ text?.value }}</h3>

            <NuxtLink :to="link?.value?.url" :target="link?.value?.target" class="btn btn-default btn-danger">
              {{ link?.value?.title }}
            </NuxtLink>
          </div>

          <div class="col-md-4 col-lg-4 offset-lg-1">
            <div class="section__head-image">
              <NuxtImg format="webp" loading="lazy" :src="image?.value?.url" alt="" width="176" height="205"></NuxtImg>
            </div><!-- /.section__head-image -->
          </div>
        </div>
      </header>
    </div>
  </div>
</template>